export default "__VITE_ASSET__0903edb1__"